import React from "react"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../../DataTable/DataTable"

class NightAuditCCAuthorizations extends React.Component {
  constructor(props) {
    super(props)
    this.itemsAndTotal = this.itemsAndTotal.bind(this);
  };

  render() {
    return(
      <div>
        <div className="panel panel-default">
          <div className="panel-body">
            <h3 className="panel-heading-text">{I18n.t('authorizations')} - {I18n.t('total')} {this.props.totals.cc_auths ? this.props.formatCurrency(this.props.totals.cc_auths) : this.props.formatCurrency(0)} - {I18n.t('count')} {this.props.totals.id_auths_count ? this.props.totals.id_auths_count : 0}</h3>
            <div className="col-sm-12">
              <DataTable 
                endpoint={`/admin/night-audits/${this.props.excluded_authorizations.length ? this.props.excluded_authorizations : false}/cc-authorizations`} 
                date_format={this.props.date_format} 
                time_format={this.props.time_format}
                delimiter={I18n.t('number.currency.format.delimiter')} 
                separator={I18n.t('number.currency.format.separator')} 
                itemsAndTotal={this.itemsAndTotal} night_audit={true} 
                audit_date={this.props.postDate} 
                exclude={this.props.excludeAuthorizations}
                export_csv_endpoint={`/admin/night-audits/${this.props.excluded_authorizations.length ? this.props.excluded_authorizations : false}/export_cc_auth_csv.csv`}
                />
            </div>
          </div>
        </div>
      </div>
    );
  };

  itemsAndTotal(items, total, count) {
    this.props.collectCCAuthorizations(items, total, count)
  };


};

export default NightAuditCCAuthorizations